module.exports = "/static/media/payment.d0cf9c89.svg";